import { render } from "./InvestorPasswordGate.vue?vue&type=template&id=98523370&scoped=true"
import script from "./InvestorPasswordGate.vue?vue&type=script&lang=js"
export * from "./InvestorPasswordGate.vue?vue&type=script&lang=js"

import "./InvestorPasswordGate.vue?vue&type=style&index=0&id=98523370&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98523370"]])

export default __exports__